<template>
  <transition name="modal-fade">
    <div v-if="value" class="modal-backdrop" @click.self="close">
      <div class="modal-container">
        
        <div class="modal-header">
          <h3>Загрузка аватарки</h3>
          <button class="btn-close" @click="close">&times;</button>
        </div>

        <div class="modal-body">
          <!-- Способ 1: Загрузка файла -->
          <div class="upload-zone" @click="$refs.fileInput.click()">
            <input 
              type="file" 
              ref="fileInput" 
              accept="image/*" 
              style="display: none" 
              @change="handleFileChange"
            />
            <!-- <p v-if="!previewUrl">Перетащите сюда фото или нажмите для выбора</p> -->
            <p v-if="!previewUrl">Нажмите сюда для выбора фото</p>
            <img v-else :src="previewUrl" class="modal-preview" alt="Превью" />
          </div>

          <div class="divider">или</div>

          <!-- Способ 2: Вставка ссылки -->
          <div class="input-group">
            <label>Ссылка на изображение:</label>
            <input 
              type="text" 
              v-model="imageUrlInput" 
              placeholder="https://example.com"
              @input="handleUrlInput"
            />
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn white" @click="close">Отмена</button>
          <button class="btn blue align-right" :disabled="!previewUrl" @click="save">Сохранить</button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AvatarUploadModal',
  props: {
    // Используем v-model (во Vue 2 это проп `value` + событие `input`)
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imageUrlInput: '',
      previewUrl: ''
    };
  },
  watch: {
    // Очищаем поля при открытии/закрытии
    value(isOpen) {
      if (isOpen) {
        this.imageUrlInput = '';
        this.previewUrl = '';
      }
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    // Чтение локального файла
    handleFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.imageUrlInput = ''; // сбрасываем ввод ссылки
        const reader = new FileReader();
        reader.onload = (event) => {
          this.previewUrl = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    // Ввод ссылки текстом
    handleUrlInput() {
      this.previewUrl = this.imageUrlInput;
    },
    // Передача готового урла/base64 в родительский компонент
    save() {
      this.$emit('save', this.previewUrl);
      this.close();
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-container {
  background: var(--background-color);
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  padding: 20px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  font-family: sans-serif;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.modal-header h3 { margin: 0; font-size: 18px; color: var(--textColor); }
.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--textColorDisabled);
}

.btn-close:hover {
  color: var(--textColor);
}

.upload-zone {
  border: 2px dashed #ccc;
  border-radius: 6px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  /* background: #f9f9f9; */
  transition: border-color 0.2s;
}
.upload-zone:hover { border-color: #42b983; }

.modal-preview {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  margin: 0 auto;
  display: block;
}

.divider { text-align: center; margin: 15px 0; color: #888; font-size: 14px; position: relative; }

.input-group { display: flex; flex-direction: column; gap: 5px; }
.input-group label { font-size: 13px; color: #666; font-weight: bold; }
.input-group input { padding: 8px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; }

.modal-footer { display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px; }
.modal-footer button { padding: 8px 16px; border: none; border-radius: 4px; cursor: pointer; font-weight: bold; }
.btn-secondary { background: #eee; color: #333; }
.btn-primary { background: #42b983; color: white; }
.btn-primary:disabled { background: #a2dec2; cursor: not-allowed; }

/* Анимация плавного появления */
.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity 0.3s; }
.modal-fade-enter, .modal-fade-leave-to { opacity: 0; }
</style>